import type { UnitPresets } from "@/libs/units/presets";

export const usWaterWellUnits: UnitPresets = {
  "Generic.Power.Hydraulic": "hp",
  "Generic.Power.Real": "kW",
  "Generic.Power.Apparent": "kVA",
  "Generic.Current": "A",
  "Generic.Density": "lb/ft³",
  "Generic.FlowRate.Liquid": "G/m",
  "Generic.FlowRate.Gas": "mscf/d",
  "Generic.Length.Large": "Feet",
  "Generic.Length.Small": "Inches",
  "Generic.Ratio.Liquid": "SCF/STB",
  "Generic.Mass": "lbs",
  "Generic.Pressure": "PSIA",
  "Generic.Speed": "ft/s",
  "Generic.Temperature": "F°",
  "Generic.Viscosity": "Centipoise",
  "Generic.Voltage": "V",
  "Generic.Volume": "gal",
  "Generic.VolumeRate.PI": "stb/d/psi",
  "Generic.Concentration": "ppm"
};

/*
{
  "Top Casing Length.write.Feet": "Feet",
  "Gas/Liquid ratio.write.SCF/STB": "SCF/STB",
  "Gas/Oil ratio.write.SCF/STB": "SCF/STB",
  "Total Liquid Rate.write.STB/D": "G/m",
  "Top of Perfs.write.Feet": "Feet",
  "Bottom Casing Length.write.Feet": "Feet",
  "Oil Rate.write.STB/D": "G/m",
  "Water Rate.write.STB/D": "G/m",
  "Datum Point (MD).write.Feet": "Feet",
  "Static Bottomhole Pressure at Datum [Pr].write.PSIA": "PSIA",
  "Producing Bottomhole Pressure at Datum [Pwf].write.PSIA": "PSIA",
  "Oil Gravity.write.API": "API",
  "Water Gravity.write.Specific Gravity": "Specific Gravity",
  "Gas Gravity.write.Specific Gravity": "Specific Gravity",
  "Bubble Point Pressure Override.write.PSIA": "PSIA",
  "Bottom Hole Temperature.write.F°": "F°",
  "Surface Temperature.write.F°": "F°",
  "Dead Oil Viscosity.write.Centipoise": "Centipoise",
  "Dead Oil Viscosity 2.write.Centipoise": "Centipoise",
  "Dead Oil Viscosity 3.write.Centipoise": "Centipoise",
  "Test Temperature.write.F°": "F°",
  "Test Temperature 2.write.F°": "F°",
  "Test Temperature 3.write.F°": "F°",
  "Top Tubing Length.write.Feet": "Feet",
  "Bottom Tubing Length.write.Feet": "Feet",
  "Target Liquid Rate.write.STB/D": "G/m",
  "Tubing Pressure.write.PSIA": "PSIA",
  "Casing Pressure.write.PSIA": "PSIA",
  "Length.convert.Inches": "Feet",
  "Total Flow Rate Entering Intake.convert.STB/D": "STB/D",
  "Pump Length.write.Feet": "Feet",
  "Motor Internal Temperature.convert.F°": "F°",
  "Motor Skin Temperature.convert.F°": "F°",
  "Shroud Interior Diameter.write.Inches": "Inches",
  "Length.convert.Feet": "Feet",
  "Minimum MLE Length.convert.Feet": "Feet",
  "Pump Depth.convert.Feet": "Feet",
  "Surface Voltage.convert.V": "V",
  "Surface kVA.convert.kVA": "kVA",
  "Length.write.Feet": "Feet",
  "Incoming Power.write.V": "V",
  "Equipment Length.convert.Feet": "Feet",
  "Target Liquid Rate.convert.STB/D": "G/m",
  "Average Liquid Density.convert.lb/ft³": "lb/ft³",
  "Required TDH.convert.Feet": "Feet",
  "Produced TDH.convert.Feet": "Feet",
  "Required Discharge Pressure.convert.PSIA": "PSIA",
  "Discharge Pressure.convert.PSIA": "PSIA",
  "Discharge Temperature.convert.F°": "F°",
  "Shut-in Thrust Load.convert.lbs": "lbs",
  "Shut-in Burst Pressure.convert.PSIA": "PSIA",
  "Motor Current.convert.A": "A",
  "Operating Temp.convert.F°": "F°",
  "Flow by Motor.convert.ft/s": "ft/s",
  "Total Voltage.convert.V": "V",
  "Startup Voltage.convert.V": "V",
  "Oil Gravity.convert.API": "API",
  "Water Gravity.convert.Specific Gravity": "Specific Gravity",
  "Gas Gravity.convert.Specific Gravity": "Specific Gravity",
  "Bubble Point Pressure.convert.PSIA": "PSIA",
  "Total Liquid Rate.convert.STB/D": "G/m",
  "Oil Rate.convert.STB/D": "G/m",
  "Water Rate.convert.STB/D": "G/m",
  "Gas Rate.write.mscf/d": "mscf/d",
  "Datum Point.convert.Feet": "Feet",
  "SBHP.convert.PSIA": "PSIA",
  "PBHP.convert.PSIA": "PSIA",
  "Intake HP.convert.hp": "hp",
  "Shaft Limit.convert.hp": "hp",
  "Pump Intake Pressure.convert.PSIA": "PSIA",
  "Fluid Above Pump (TVD).convert.Feet": "Feet",
  "Fluid Level (MD).convert.Feet": "Feet",
  "Well Flowing Pressure (Datum).convert.PSIA": "PSIA",
  "Well Flowing Pressure (Perfs).convert.PSIA": "PSIA",
  "Pump Intake Temperature.convert.F°": "F°",
  "Oil Rate (in situ).convert.STB/D": "G/m",
  "Gas Rate @ Intake.convert.STB/D": "mscf/d",
  "Gas Rate after Separation.convert.scf/d": "mscf/d",
  "Total Flowrate Entering Pump.convert.STB/D": "STB/D",
  "Total Flowrate Entering Intake.convert.STB/D": "STB/D",
  "Gas Pressure at Intake.convert.PSIA": "PSIA",
  "Average Ambient Temperature.convert.F°": "F°",
  "Cable Temperature.convert.F°": "F°",
  "Max Amps at Temperature.convert.A": "A",
  "Total Cables Voltage Loss.convert.V": "V",
  "Total Cables Power Loss.convert.kW": "kW",
  "Cable Length .convert.Meters": "Feet",
  "Max Amps at Temp.convert.A": "A",
  "Volt Loss / 1000ft.convert.VA": "VA",
  "Total Volt Loss.convert.VA": "VA",
  "Required Voltage.convert.V": "V",
  "Required kVA.convert.kVA": "kVA",
  "Liquid Flow Rate Entering Intake.convert.STB/D": "STB/D",
  "Motor Winding Temperature.convert.F°": "F°",
  "Motor Temp Rating.convert.F°": "F°",
  "Produced Discharge Pressure.convert.PSIA": "PSIA",
  "Pressure Drop Past Motor.convert.PSIA": "PSIA",
  "Bottom of Intake Depth.convert.Feet": "Feet",
  "Water Rate (in situ).convert.STB/D": "STB/D",
  "Productivity Index.convert.stb/d/psi": "stb/d/psi"
};
*/
